import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function MicIcon(props: IconProps) {
    return <Icon {...props} iconKey={"mic"}/>
}
